import React,{ useState, useEffect, useRef } from 'react';
import { CheckCircleFilled, StopOutlined } from '@ant-design/icons';

import logo from '../../image/logo.svg'

import './Contrast.less';

const Contrast = ({type}) =>{
  
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  if(type === 'quality'){
    return (    
      <div className="Contrast-box">
        <div className="Contrast-title">Unmatched safety, quality and efficacy</div>
        <div className="Contrast-quality-box" style={width > 770? {}:{width: 'calc(100% - 20px)'}}>
          <div className="Contrast-content-item">
            <div style={width > 770? {width: '35%'}:{width: '50%'}}></div>
            <div style={width > 770? {width: '35%'}:{width: '25%'}}><img style={{width:85}} src={logo} alt="" /></div>
            <div style={width > 770? {width: '35%'}:{width: '25%'}}>Other Urolithin A</div>
            {width > 770?
              <div>Why it matters</div>
              :
              ''
            }
          </div>
          <div className="Contrast-content-item">
            <div style={width > 770? {width: '35%'}:{width: '50%'}}>Clinically proven safe & effective</div>
            <div style={width > 770? {width: '35%'}:{width: '25%'}}><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            <div style={width > 770? {width: '35%'}:{width: '25%'}}><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>
            {width > 770?
              <div>Mitopure is the only clinically-tested and validated form of Urolithin A, with safety and efficacy demonstrated across multiple placebo-controlled trials.</div>
              :
              ''
            }
          </div>
          <div className="Contrast-content-item">
            <div style={width > 770? {width: '35%'}:{width: '50%'}}>Clinically proven safe & effective</div>
            <div style={width > 770? {width: '35%'}:{width: '25%'}}><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            <div style={width > 770? {width: '35%'}:{width: '25%'}}><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>
            {width > 770?
              <div>Mitopure is the only clinically-tested and validated form of Urolithin A, with safety and efficacy demonstrated across multiple placebo-controlled trials.</div>
              :
              ''
            }
          </div>
          <div className="Contrast-content-item">
            <div style={width > 770? {width: '35%'}:{width: '50%'}}>Clinically proven safe & effective</div>
            <div style={width > 770? {width: '35%'}:{width: '25%'}}><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            <div style={width > 770? {width: '35%'}:{width: '25%'}}><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>
            {width > 770?
              <div>Mitopure is the only clinically-tested and validated form of Urolithin A, with safety and efficacy demonstrated across multiple placebo-controlled trials.</div>
              :
              ''
            }
          </div>
          <div className="Contrast-content-item">
            <div style={width > 770? {width: '35%'}:{width: '50%'}}>Clinically proven safe & effective</div>
            <div style={width > 770? {width: '35%'}:{width: '25%'}}><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            <div style={width > 770? {width: '35%'}:{width: '25%'}}><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>
            {width > 770?
              <div>Mitopure is the only clinically-tested and validated form of Urolithin A, with safety and efficacy demonstrated across multiple placebo-controlled trials.</div>
              :
              ''
            }
          </div>
          <div className="Contrast-content-item">
            <div style={width > 770? {width: '35%'}:{width: '50%'}}>Clinically proven safe & effective</div>
            <div style={width > 770? {width: '35%'}:{width: '25%'}}><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            <div style={width > 770? {width: '35%'}:{width: '25%'}}><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>
            {width > 770?
              <div>Mitopure is the only clinically-tested and validated form of Urolithin A, with safety and efficacy demonstrated across multiple placebo-controlled trials.</div>
              :
              ''
            }
          </div>
        </div>
      </div>
    )
  }else{
    return (
      <div className="Contrast-box" style={{background: `url(${require('../../image/Contrast-2800x1015.avif')})`, backgroundSize:'100%'}}>
        <div className="Contrast-title">Unmatched safety, quality and efficacy</div>
        <div className="Contrast-nutrition-box">
          <div className="Contrast-content-item">
            <div></div>
            <div>Hydration</div>
            <div>Firmness</div>
            <div>Wrinkles</div>
            {width > 770? <div>Elasticity</div>:''}
            {width > 770? <div>Redness</div>:''}
            {width > 770? <div>Safe<p>for daily use</p></div>:''}
          </div>
          <div className="Contrast-content-item">
            <div><img style={{width:85}} src={logo} alt="" /></div>
            <div><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            <div><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>
            <div><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            {width > 770? <div><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>:''}
            {width > 770? <div><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>:''}
            {width > 770? <div><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>:''}
          </div>
          <div className="Contrast-content-item">
            <div>Retinol</div>
            <div><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            <div><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>
            <div><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            {width > 770? <div><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>:''}
            {width > 770? <div><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>:''}
            {width > 770? <div><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>:''}
          </div>
          <div className="Contrast-content-item">
            <div>Vitamin C</div>
            <div><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            <div><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>
            <div><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            {width > 770? <div><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>:''}
            {width > 770? <div><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>:''}
            {width > 770? <div><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>:''}
          </div>
          <div className="Contrast-content-item">
            <div>Peptides</div>
            <div><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            <div><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>
            <div><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>
            {width > 770? <div><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>:''}
            {width > 770? <div><CheckCircleFilled style={{ fontSize: 20, color: '#000' }}/></div>:''}
            {width > 770? <div><StopOutlined style={{ fontSize: 18, color: '#000' }}/></div>:''}
          </div>
        </div>
      </div>
    )
  }
}

export default Contrast